export default __webpack_public_path__ + "static/media/mail_blue_icon.dc855f9f.svg";